// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentV2PaymentTypeModel } from './enrollmentV2PaymentTypeModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentV2PaymentTypeModels {
    'success': boolean;
    'notSuccessful'?: boolean;
    'messages': Array<string> | null;
    'data': Array<EnrollmentV2PaymentTypeModel> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentV2PaymentTypeModels>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "notSuccessful",
            "baseName": "notSuccessful",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<EnrollmentV2PaymentTypeModel>"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentV2PaymentTypeModels.attributeTypeMap;
    }
}
